import { Outlet } from "react-router-dom";

const RolesAndPermissions = () => {
  return (
    <div>
      {/* <h2>Roles and Permissions</h2> */}
      <Outlet />
    </div>
  );
};

export default RolesAndPermissions;